import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  Container,
  Dropdown,
  Form,
  Grid,
  Divider,
  Segment,
  Header
} from "semantic-ui-react";
import { useAuth } from "../../../AuthenticationStore";
import ReactPaginate from "react-paginate";
import "./Indicators.scss";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import { NavLink } from "react-router-dom";

function paginate(array, page_size, page_number) {
  return array.slice(page_number * page_size, (page_number + 1) * page_size);
}

const Indicators = () => {
  let history = useHistory();
  // const [loadData, setLoadData] = useState(true);
  const [dataDahboard, setDataDahboard] = useState([]);
  const { indicatorService } = useAuth();
  const [dataDashboardPagination, setDataDashboardPagination] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [listCampaings, setListCampaings] = useState([]);

  useEffect(() => {
    if (!indicatorService) return;
    const getListDashboard = async () => {
      const responseCampaigns = await indicatorService.getCompanyControlPanel();
      const data = responseCampaigns.object || [];
      const listCampaingsTemp = [];
      data.map(item => {
        listCampaingsTemp.push({
          key: item.campaignId,
          text: item.name,
          value: item.campaignId
        });
        return item;
      });

      setDataDahboard(data);
      setTotalPage(data.length);
      setListCampaings(listCampaingsTemp);
      setDataDashboardPagination(paginate(data, 2, 0));
    };
    getListDashboard();
  }, [indicatorService]);

  const optionsChartDashboard = label => {
    return {
      chart: {
        offsetY: 0
      },
      fill: {
        gradient: {
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          shade: "light",
          shadeIntensity: 0.4,
          stops: [0, 50, 53, 91]
        },
        type: "gradient"
      },
      labels: [label],
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              offsetY: -120,
              show: true
            },
            value: {
              fontSize: "22px",
              offsetY: -20
            }
          },
          endAngle: 90,
          startAngle: -90,
          track: {
            background: "#e7e7e7",
            margin: 5,
            shadow: {
              blur: 2,
              color: "#999",
              enabled: true,
              left: 0,
              opacity: 1,
              top: 2
            }, // margin is in pixels
            strokeWidth: "97%"
          }
        }
      }
    };
  };

  const changePage = i => {
    setDataDashboardPagination(paginate(dataDahboard, 2, i.selected));
  };

  const getDetailCampaing = (_, ev) => history.push("/indicators/" + ev.value);

  return (
    <Container>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Form>
              <Form.Field>
                <Dropdown
                  placeholder="Seleccione una campaña"
                  fluid
                  search
                  selection
                  options={listCampaings}
                  onChange={getDetailCampaing}
                />
              </Form.Field>
            </Form>
          </Grid.Column>
        </Grid.Row>
        <Divider inverted />
        <Grid.Row>
          <Grid.Column className="center">
            <ReactPaginate
              previousLabel={"<<"}
              nextLabel={">>"}
              breakLabel={"..."}
              pageCount={totalPage / 2}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={changePage}
              containerClassName={"pagination flex-wrap"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-link"}
              nextClassName={"page-link"}
              previousLinkClassName={"page-item"}
              nextLinkClassName={"page-item"}
              pageClassName={"page-item"}
              activeClassName={"active"}
              breakClassName={"page-link"}
              breakLinkClassName={"page-item"}
            />
          </Grid.Column>
        </Grid.Row>

        <div className="row">
          {dataDashboardPagination.map((campaign, key) => (
            <div key={key} className="campaign-container col-12 col-lg-6">
              <div>
                <Header size="small" className="indicator-campaign-title">
                  {/* white space */}
                  <div>&nbsp;</div>
                  <h3>{campaign.name}</h3>
                  <span className="badge badge-danger">
                    <i className="fa fa-calendar"></i> Dt {campaign.passDays}
                  </span>{" "}
                  <span className="badge badge-warning">
                    <i className="fa fa-calendar"></i> Df {campaign.missingDays}
                  </span>{" "}
                  <span className="badge badge-danger">
                    <i className="fa fa-eye"></i> Cm {campaign.seeCustomer}
                  </span>{" "}
                  <span className="badge badge-warning">
                    <i className="fa fa-eye-slash"></i> Cnm{" "}
                    {campaign.notSeeCustomer}
                  </span>
                </Header>
                <div className="row row-badge-indicator">
                  <div className="card bg-info d-flex wrap-fa-back col-md-4">
                    <div className="card-body inner-fa-back text-indicator-amount">
                      <h3>
                        <i className="fa fa-money"></i> Potenciales
                      </h3>
                      <NumberFormat
                        value={campaign.targetAmount}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                        className={"indicator-value"}
                      />
                    </div>
                  </div>
                  <div className="card bg-primary d-flex wrap-fa-back col-md-4">
                    <div className="card-body inner-fa-back text-indicator-amount">
                      <h3>
                        <i className="fa fa-money"></i> Meta
                      </h3>
                      <NumberFormat
                        value={campaign.projectedAmount}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                        className={"indicator-value"}
                      />
                    </div>
                  </div>
                  <div className="card bg-success d-flex wrap-fa-back col-md-4">
                    <div className="card-body inner-fa-back text-indicator-amount">
                      <h3>
                        <i className="fa fa-money"></i> Colocado
                      </h3>
                      <NumberFormat
                        value={campaign.totalAmount}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                        className={"indicator-value"}
                      />
                    </div>
                  </div>
                </div>
                <Segment className="campaign-indicator-container">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <NavLink to={"/indicators/" + campaign.campaignId}>
                          <Chart
                            options={optionsChartDashboard("Valores vs Meta")}
                            series={[campaign.percentageAmount.toFixed(2)]}
                            type="radialBar"
                            height="300"
                          />
                        </NavLink>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
                <div className="row row-badge-indicator" style={{ top: "0px" }}>
                  <div className="card bg-info d-flex wrap-fa-back wrap-fa-back-people col-md-4">
                    <div className="card-body inner-fa-back">
                      <h3>
                        <i className="fa fa-money"></i> Potenciales
                      </h3>
                      <NumberFormat
                        value={campaign.targetCustomer}
                        displayType={"text"}
                        className={"indicator-value"}
                      />
                    </div>
                  </div>
                  <div className="card bg-primary d-flex wrap-fa-back wrap-fa-back-people col-md-4">
                    <div className="card-body inner-fa-back">
                      <h3>
                        <i className="fa fa-money"></i> Meta
                      </h3>
                      <NumberFormat
                        value={campaign.projectedCustomer}
                        displayType={"text"}
                        className={"indicator-value"}
                      />
                    </div>
                  </div>
                  <div className="card bg-success d-flex wrap-fa-back wrap-fa-back-people col-md-4">
                    <div className="card-body inner-fa-back">
                      <h3>
                        <i className="fa fa-money"></i> Colocado
                      </h3>
                      <NumberFormat
                        value={campaign.totalCustomer}
                        displayType={"text"}
                        className={"indicator-value"}
                      />
                    </div>
                  </div>
                </div>
                <Segment className="campaign-indicator-container">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column
                        mobile={16}
                        tablet={16}
                        computer={16}
                        style={{ top: "0px" }}
                      >
                        <NavLink to={"/indicators/" + campaign.campaignId}>
                          <Chart
                            options={optionsChartDashboard("Clientes vs Meta")}
                            series={[campaign.percentageCustomer.toFixed(2)]}
                            type="radialBar"
                            height="300"
                          />
                        </NavLink>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </div>
            </div>
          ))}
        </div>
      </Grid>
      <Grid.Column
        mobile={16}
        tablet={16}
        computer={16}
        style={{ top: "-185px" }}
        className="indicators-text-help"
      >
        <span>Dt = Dias transcurridos</span>&nbsp;
        <span>Df = Dias faltantes</span>&nbsp;
        <span>Cm = Clientes ofertados</span>&nbsp;
        <span>Cnm = Clientes no ofertados</span>&nbsp;
      </Grid.Column>
    </Container>
  );
};

export default Indicators;
